"use strict";

Shopify.theme.jsCollectionProducts = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsCollectionProducts = $.extend(this, Shopify.theme.getSectionData($section));

    if ((($(window).width() < 480 && $('#'+$section.attr('id')+' .gallery-cell').length > 2) || ($(window).width() < 799 && $('#'+$section.attr('id')+' .gallery-cell').length > 4) || ($(window).width() > 1439 && $('#'+$section.attr('id')+' .gallery-cell').length > 7) || ($(window).width()<1440 && $(window).width()>798))) {
      this.createSlider($section.attr('id'));
    }
  },
  createSlider: function createSlider(id) {
    $('#'+id+' .layout--slider').addClass('slider-enabled');
    var mySwiper = new Swiper('#'+id+' .collection-products .slider-gallery', {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      grabCursor: true,
      spaceBetween:2,
      centeredSlides: false,
      // Navigation arrows
      navigation: {
        nextEl:  '#'+id+' .swiper-button.next',
        prevEl: '#'+id+' .swiper-button.previous',
      },
      breakpoints: {
        480: {
          slidesPerView: 3
        },
        600:{
          slidesPerView: 4
        },
        798: {
          slidesPerView: 5
        },
        1439: {
          slidesPerView: 6
        }
      }
    });



    // var collectionProductsSlider = $(window).width() < 799 || $(window).width() > 1439 ? ($('.collection-products').hasClass('layout--slider') ? $('.collection-products .slider-gallery') : $('.collection-products')) : $('.collection-products .slider-gallery');
    // var slideData = {
    //   products_per_slide: $(window).width() < 480 ? 1 : $(window).width() < 798 ? 2 : $(window).width() > 1439 ? 6 : this.products_per,
    //   products_available: this.products_available,
    //   products_limit: this.products_limit,
    //   cellAlign: "left",
    //   wrapAround: true
    // };
    // $(collectionProductsSlider).flickity({
    //   lazyLoad: 2,
    //   freeScroll: true,
    //   imagesLoaded: true,
    //   draggable: true,
    //   cellAlign: 'left',
    //   wrapAround: slideData.wrapAround,
    //   pageDots: false,
    //   contain: true,
    //   prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
    //   initialIndex: 0,
    //   arrowShape: arrowShape,
    //   on: {
    //     ready: function ready() {
    //       // Reset layout to avoid collapsing issues
    //       setTimeout(function () {
    //         $(collectionProductsSlider).flickity('resize');
    //       }, 500);
    //     }
    //   }
    // });
  },
  unload: function unload($section) {
    // var $slider = $section.find('.flickity-enabled');
    // $slider.flickity('destroy');
  }
};